<script setup lang="ts">
import {
    DropdownMenuSubTrigger,
    type DropdownMenuSubTriggerProps,
} from "radix-vue";
import { ChevronRight } from "lucide-vue-next";
import { cn } from "@/lib/utils";

const props = defineProps<DropdownMenuSubTriggerProps & { class?: string }>();
</script>

<template>
    <DropdownMenuSubTrigger
        v-bind="props"
        :class="[
            cn(
                'rounded-sm px-2 py-1.5 text-sm focus:bg-stone-100 data-[state=open]:bg-stone-100 dark:focus:bg-stone-800 dark:data-[state=open]:bg-stone-800 flex cursor-default items-center outline-none select-none',
                props.class,
            ),
        ]"
    >
        <slot />
        <ChevronRight class="h-4 w-4 ml-auto" />
    </DropdownMenuSubTrigger>
</template>
